import { createColumn, ColumnWidth } from '../createColumn';
import { IColumn } from 'office-ui-fabric-react/lib/DetailsList';
import ColumnStrings from '../columns.resx';
import { Facet } from '../../../models/Facet';
import { UserFieldWithHoverCard } from '../../fields/user/UserFieldWithHoverCard';
import { IItemCache } from '../../../models/IItemCacheObserver';
import { modifiedByPersonFacet, displayNameFacet } from '../../../facets/ItemFacets';
import { emailFacet, sipFacet, pictureFacet } from '../../../facets/PersonFacets';

export const modifiedByColumn: IColumn = createColumn({
  key: new Facet('modifiedByColumn').id,
  name: ColumnStrings.ModifiedBy,
  fieldName: '',
  minWidth: ColumnWidth.regularMin,
  maxWidth: ColumnWidth.regularMax,
  isCollapsable: true
}, UserFieldWithHoverCard)((itemCache: IItemCache, itemKey: string) => {
  const {
    modifiedByPerson
  } = itemCache.demandItem({
    modifiedByPerson: modifiedByPersonFacet
  }, itemKey);

  if (modifiedByPerson && modifiedByPerson.itemKey) {
    const userFacets = itemCache.demandItem({
      displayName: displayNameFacet,
      email: emailFacet,
      sip: sipFacet,
      picture: pictureFacet
    }, modifiedByPerson.itemKey);

    return {
      users: userFacets ?
        [
          {
            title: userFacets.displayName || '',
            email: userFacets.email || '',
            sip: userFacets.sip || '',
            picture: userFacets.picture || '',
            personKey: modifiedByPerson.itemKey
          }
        ] : []
    };
  } else {
    return {
      users: []
    };
  }
});
